/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Contact_Save_SuccessInputs */

const en_case_contact_save_success = /** @type {(inputs: Case_Contact_Save_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact saved.`)
};

const pt_br2_case_contact_save_success = /** @type {(inputs: Case_Contact_Save_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contato salvo.`)
};

/**
* | output |
* | --- |
* | "Contact saved." |
*
* @param {Case_Contact_Save_SuccessInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_contact_save_success = /** @type {((inputs?: Case_Contact_Save_SuccessInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Contact_Save_SuccessInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_contact_save_success(inputs)
	return pt_br2_case_contact_save_success(inputs)
});